"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dateToEpochSeconds_1 = __importDefault(require("../utils/dateToEpochSeconds"));
function updateSectionFirstStats(aggregatedStat, sessionEvent) {
    const { session } = sessionEvent;
    const { timeFinished } = session;
    if (!timeFinished)
        return;
    const timeFinishedSeconds = (0, dateToEpochSeconds_1.default)(timeFinished);
    if ((aggregatedStat === null || aggregatedStat === void 0 ? void 0 : aggregatedStat.firstStudied) &&
        aggregatedStat.firstStudied < timeFinishedSeconds)
        return;
    return {
        firstStudied: timeFinishedSeconds,
        firstScore: session.sessionScore
    };
}
exports.default = updateSectionFirstStats;
